var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5, 0) scale(1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66536 8.91844H6.33203C6.6987 8.91844 6.9987 8.61844 6.9987 8.25177V4.91844H8.0587C8.65203 4.91844 8.95203 4.19844 8.53203 3.77844L5.47203 0.718437C5.21203 0.458438 4.79203 0.458438 4.53203 0.718437L1.47203 3.77844C1.05203 4.19844 1.34536 4.91844 1.9387 4.91844H2.9987V8.25177C2.9987 8.61844 3.2987 8.91844 3.66536 8.91844ZM0.998698 10.2518H8.9987C9.36537 10.2518 9.66537 10.5518 9.66537 10.9184C9.66537 11.2851 9.36537 11.5851 8.9987 11.5851H0.998698C0.632031 11.5851 0.332031 11.2851 0.332031 10.9184C0.332031 10.5518 0.632031 10.2518 0.998698 10.2518Z",
    fill: "#0065B3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadTooltip);
export default __webpack_public_path__ + "static/media/icon-upload-tooltip.990dccfda11ba9f79f3b39a55b920577.svg";
export { ForwardRef as ReactComponent };